import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProgressBarInputData } from '../types/ProgressBarInputData';

@Component({
  selector: 'lp2-study-bundle-child-header',
  templateUrl: './study-bundle-child-header.component.html',
  styleUrls: ['./study-bundle-child-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudyBundleChildHeaderComponent {
  @Input() title: string;
  @Input() progressBarData: ProgressBarInputData[];
}



// WEBPACK FOOTER //
// ./ts/app/shared/study-bundle-child-header/study-bundle-child-header.component.ts